import Insight from "../insightClass";
import React from "react";
import { insight42Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight073 = new Insight(
  "24 October 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight42Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-10-24)",
  "",
  `Vestas has suspended its plan to build a major blade manufacturing facility in Szczecin, Poland, citing lower-than-expected offshore wind demand across Europe. Announced in 2024 and intended to support the 15 MW turbine platform, the plant was projected to open in 2026 and create over 1,000 jobs.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-10-24)</h1>
    <h2></h2>
    <p className="article-date">24 October 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>
      1. Vestas pauses flagship offshore blade factory in Poland as European
      demand weakens
    </h3>
    <p>
      Vestas has suspended its plan to build a major blade manufacturing
      facility in Szczecin, Poland, citing lower-than-expected offshore wind
      demand across Europe. Announced in 2024 and intended to support the 15 MW
      turbine platform, the plant was projected to open in 2026 and create over
      1,000 jobs. The decision reflects the impact of high financing costs and
      slower final investment decisions, which are dampening momentum in the
      European offshore wind market. It also raises concerns that European
      manufacturers could lose competitiveness to lower-cost Asian suppliers if
      policy support and auction schedules remain inconsistent.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This development will ripple through the Baltic supply chain: tooling
      contracts, supplier investments, and workforce training initiatives are
      likely to slow or be rescheduled. For developers, turbine procurement risk
      has increased for 2025–26 auction projects. We advise negotiating
      diversified sourcing options and including indexed price-adjustment
      clauses tied to materials and interest rates. Policymakers should see this
      as a wake-up call: Europe needs longer auction visibility (at least three
      years), realistic strike price floors aligned with current WACC, and
      permitting timelines with guaranteed certainty. Otherwise, European
      manufacturing will erode just as energy security concerns are
      intensifying.
    </p>
    <h3>
      2. UK National Wealth Fund backs £28 million O&M hub in Great Yarmouth
    </h3>
    <p>
      The UK’s National Wealth Fund has approved a £15 million loan toward a £28
      million offshore wind operations and maintenance (O&M) campus in Great
      Yarmouth. The project includes refurbishment of a 240 m quay, construction
      of a new crew transfer vessel (CTV) pontoon, and major utilities upgrades.
      Expected to create around 650 jobs, the facility will support RWE’s
      Norfolk Zone projects (three sites totaling approximately 4.2 GW) and
      strengthen the East Coast’s offshore energy infrastructure.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This is a strategically placed infrastructure investment. O&M hubs provide
      the long-term economic anchor of offshore wind clusters. The upgrades will
      help de-risk quayside congestion and shorten transit times for vessels
      across the Norfolk Zone, improving turbine availability and lowering LCOE.
      For AR7 and AR8 bidders, proximity to an enhanced O&M base is bankable —
      enabling shorter steaming times, shared spare-parts pools, and improved
      labor retention. With UK port capacity still constrained, WeBridge expects
      Yarmouth’s investment to attract secondary developments in component
      storage, training, and decommissioning services, positioning it as a
      second major East Coast hub alongside Grimsby and the Humber.
    </p>
    <h3>
      3. UK government confirms single timetable for Allocation Round 7 (AR7)
    </h3>
    <p>
      The Department for Energy Security and Net Zero (DESNZ) has confirmed that
      Allocation Round 7 will proceed under a single, unified timetable. The
      sealed-bid window is scheduled for 11–17 November 2025, with results
      expected by 14 January 2026. Officials say the consolidated schedule
      provides better certainty for developers after a complex prequalification
      phase that had raised concerns of further delay into 2026.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      While welcome, the compressed bidding window and early-January results
      create a narrow margin for developers to finalize supply pricing and
      financing before year-end market shifts. We recommend:
    </p>
    <ol>
      <li>
        Revalidating supplier quotes against Q1 2026 inflation and FX trends.
      </li>
      <li>
        Reviewing grid-connection milestones in light of updated consent
        conditions.
      </li>
      <li>
        Modelling more constrained installation vessel and cable-supply
        timelines.
      </li>
    </ol>
    <p>
      Bid discipline remains essential — following 2024–25 cost escalation,
      realistic capex and capacity-factor assumptions are crucial. Unless
      indexation mechanisms and reference prices fully reflect current WACC, AR7
      may still deliver limited capacity uptake.
    </p>
    <h3>
      4. Jan De Nul launches Fleeming Jenkin, the world’s largest cable-laying
      vessel
    </h3>
    <p>
      Jan De Nul has launched the Fleeming Jenkin — a 215 m, 28,000-ton
      cable-laying vessel (CLV) designed for ultra-long, heavy export cables in
      water depths up to 3,000 m. Scheduled for delivery in late 2026, it will
      debut on TenneT’s 2 GW HVDC grid program connecting the Netherlands and
      Germany, laying roughly 2,800 km of subsea export cables — more than
      double the capacity of legacy systems. A sister vessel, William Thomson,
      is under construction. Together, they represent a new class of
      high-efficiency assets supporting Europe’s offshore grid expansion.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Grid connections remain Europe’s tightest bottleneck. High-capacity CLVs
      like Fleeming Jenkin are the industry’s relief valve. The vessel expands
      deep-water, long-haul installation capacity and increases weather-window
      resilience. Developers should align export-system design and permitting
      early with actual vessel specifications (bending radii, carousel limits,
      deck load). Installation slots should be reserved well in advance of
      turbine EPCI. We expect mild downward pressure on day-rates from 2027 as
      new tonnage arrives, but 2025–26 capacity remains tight. Maintain schedule
      contingency for cable logistics and jointing operations.
    </p>
    <h3>
      5. Europe reassesses China’s growing role in offshore wind supply chains
    </h3>
    <p>
      European governments are reviewing the participation of Chinese OEMs and
      component suppliers in critical offshore wind infrastructure amid concerns
      over pricing, cybersecurity, and strategic dependence on rare-earth
      materials. Chinese turbines are reportedly 30–40% cheaper than European
      equivalents, drawing attention to the balance between cost competitiveness
      and energy security. The UK’s pending decision on Ming Yang’s proposed
      Scottish factory is seen as a bellwether for how Europe will navigate
      supply-chain openness versus resilience.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Procurement strategies are becoming increasingly geopolitical. While mixed
      sourcing can reduce capex, it can raise scrutiny in financing and
      regulatory reviews. Expect lenders to apply origin-of-risk premiums unless
      national frameworks define clear vendor conditions — such as source-code
      escrow, on-shore data hosting, and local key management. For European OEMs
      and tier-2 suppliers, this is a pivotal window to push for
      industrial-policy tools: capex credits for nacelle, blade, magnet, and
      converter manufacturing. We foresee heightened due-diligence standards for
      software and data security, along with selective but significant
      safeguards on critical components — short of a blanket exclusion that
      would raise LCOE dramatically.
    </p>
    <h3>6. U.S. offshore wind policy shift hits shipbuilders and ports</h3>
    <p>
      U.S. shipyards and port projects have been severely impacted by recent
      policy reversals, with orders for new offshore wind vessels effectively
      frozen and $679 million in federal port grants canceled. Projects
      including a $475 million turbine installation vessel have been halted, and
      developers warn that permit reviews and stop-work orders are disrupting
      schedules and financing. While some facilities, such as South Brooklyn
      Marine Terminal, continue to progress, the broader U.S. offshore wind
      supply chain faces a multi-year reset.
    </p>
    <p>WeBridge Insights:</p>
    <p>
      Global vessel scarcity will tighten further as the U.S. market stalls.
      Expect redeployment of high-spec assets — including WTIVs, rock
      installers, and CLVs — to Europe and Asia-Pacific through 2026, slightly
      easing capacity constraints elsewhere. For manufacturers and yards exposed
      to U.S. projects, diversify order books geographically and negotiate
      flexible delivery clauses. European and UK developers may gain a
      short-term advantage in vessel availability, but should monitor U.S.
      policy shifts that could reverse this trend. EPC margins will remain
      highly sensitive to mobilization distances and port availability;
      incorporate performance buffers for weather and transit delays.
    </p>
    <h3>
      7. ASEAN interconnection vision: Vietnam–Malaysia–Singapore offshore wind
      link by 2034 (Phase 1)
    </h3>
    <p>
      Malaysia’s energy minister has outlined a 2 GW offshore wind development
      and transmission scheme connecting Vietnam, Malaysia, and Singapore, with
      Phase 1 targeted for completion by 2034. Roughly 700 MW will serve
      Malaysia, while about 1.3 GW will be exported to Singapore. A potential
      Phase 2 would extend north through Cambodia, Laos, and Thailand before
      looping back to Peninsular Malaysia. The initiative reflects growing
      momentum toward regional power-trade integration and cross-border offshore
      wind monetization.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      The real breakthrough lies not just in generation, but in bankable
      cross-border transmission. Expect hybrid commercial models combining
      CfDs/CFEs, wheeling tariffs, and capacity-rights mechanisms. Key risks
      include route permitting across EEZ boundaries, converter-station siting,
      credit quality of multiple offtakers, and regulatory harmonization. For
      OEMs and cable manufacturers, the project represents a decade-long
      pipeline if multilateral financing structures materialize. For Singaporean
      buyers, long-term PPAs indexed to inflation and congestion will be
      crucial; for Vietnamese sponsors, early seabed mapping and synchronized
      grid codes will determine execution speed.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
